{
  "searchPlaceholder": "Rechercher par prénom ou courriel",
  "emailLabel": "Courriel",
  "emailPlaceholder": "nom@exemple.com"
}
